import { useMutation, useQueryClient } from "@tanstack/react-query";
import { UserProfileDto, UserRole } from "@green0meter/api-client";

import { DOMAIN_USERS } from "../domain";

import { usersApi } from "@api/services";
import { roleGuard } from "@api";

export const ACTION_BLOCK_USER = "BLOCK_USER";

const allowedRoles = [UserRole.Owner, UserRole.Manager];

const blockUser = async (userId: string): Promise<void> => {
  const response = await usersApi.usersControllerBlockUser(userId);

  return response.data;
};

export const useBlockUser = (
  user: UserProfileDto | null,
): {
  blockUser: (userId: string) => void;
  blockUserEnabled: boolean;
  isSuccessBlockUser: boolean;
  isPendingBlockUser: boolean;
} => {
  const enabled = roleGuard(user, allowedRoles);
  const queryClient = useQueryClient();

  const { mutate, isSuccess, isPending } = useMutation({
    mutationKey: [DOMAIN_USERS, ACTION_BLOCK_USER],
    mutationFn: enabled ? blockUser : undefined,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [DOMAIN_USERS] });
    },
  });

  return {
    blockUser: mutate,
    blockUserEnabled: enabled,
    isSuccessBlockUser: isSuccess,
    isPendingBlockUser: isPending,
  };
};
